/* eslint-disable @typescript-eslint/no-explicit-any */
import { Link } from "react-router-dom";
import Regularimg from "../../assets/icons/Icon_ Regulatory.png";
import gmpimg from "../../assets/icons/Icon_GMP.png";
import pharmaimg from "../../assets/icons/Icon_Pharma.png";
import itimg from "../../assets/icons/Icon_IT.png";
import training from "../../assets/icons/Icon_Trainings.png";
import development from "../../assets/icons/productDevelopment.png";
import Carousel from "../Carousel";

// Types
type ServicePoint = {
  text: string;
  link: string;
};

type Service = {
  id: number;
  title: string;
  img: string;
  points: ServicePoint[];
};

// Services Data
const services: Service[] = [
  {
    id: 1,
    title: "Regulatory Services",
    img: Regularimg,
    points: [
      { text: "Strategic Regulatory Planning", link: "/regulatory-services/strategic-regulatory-planning" },
      { text: "Comprehensive eCTD & SPL Publishing", link: "/regulatory-services/comprehensive-ectd-spl" },
      { text: "DMF Management", link: "/regulatory-services/global-drug-master-file-dmf" },
      { text: "Dossier Management", link: "/regulatory-services/dossier-management" },
      { text: "Regulatory Representation", link: "/regulatory-services/regulatory-representation-services" },
      { text: "Regulatory Support Services", link: "/regulatory-services/regulatory-support-services" },
    ],
  },
  {
    id: 2,
    title: "GMP Audits & Compliance",
    img: gmpimg,
    points: [
      { text: "GMP Audits", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
      { text: "Pre-FDA Inspection Compliance", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
      { text: "Post-FDA Inspection Compliance", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
      { text: "Data-Integrity Compliance", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
      { text: "Vendor Audits", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
      { text: "Routine GMP Compliance", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
      { text: "GMP Trainings", link: "/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" },
    ],
  },
  {
    id: 3,
    title: "Pharma Project Management",
    img: pharmaimg,
    points: [
      { text: "Product Development – API & Formulations", link: "/pharma-project-management/product-development-api-and-formulations" },
      { text: "Analytical Development", link: "/pharma-project-management/analytical-development-and-microbiology-services" },
      { text: "Clinical Studies & Bioequivalence", link: "/pharma-project-management/product-development-api-and-formulations" },
      { text: "Business Development", link: "/pharma-project-management/business-development-services" },
      { text: "Pharmacovigilance Support", link: "/pharma-project-management/product-development-api-and-formulations" },
      { text: "Turnkey Projects", link: "/pharma-project-management/product-development-api-and-formulations" },
      { text: "RLD Sourcing", link: "/pharma-project-management/product-development-api-and-formulations" },
    ],
  },
  {
    id: 4,
    title: "IT Solutions for Pharma",
    img: itimg,
    points: [
      { text: "Quality Management System", link: "/it-solutions-for-pharma/enterprise-quality-management-system-eqms" },
      { text: "Publishing Software", link: "/it-solutions-for-pharma/ectd-publishing-software" },
      { text: "Pharmacovigilance", link: "/it-solutions-for-pharma/pharmacovigilance-and-drug-safety-software" },
      { text: "Clinical Trial Management", link: "/it-solutions-for-pharma/clinical-trial-management-platform" },
    ],
  },
  {
    id: 5,
    title: "Trainings",
    img: training,
    points: [
      { text: "Regulatory Trainings", link: "/trainings/regulatory-training-programs" },
      { text: "GMP Trainings", link: "/trainings/gmp-training-programs" },
      { text: "Corporate Trainings", link: "/trainings/corporate-training-and-professional-development" },
    ],
  },
  {
    id: 6,
    title: "Product Development & Analytical Solutions",
    img: development,
    points: [
      { text: "Product Development", link: "/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services" },
      { text: "Method Development", link: "/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services" },
      { text: "Validations", link: "/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services" },
      { text: "QSAR, Genetoxicity Study by Software", link: "/product-development-and-analytical-solutions/product-development-and-analytical-solutions" },
      { text: "Elemental impurities", link: "/product-development-and-analytical-solutions/product-development-and-analytical-solutions" },
      { text: "Stability study", link: "/product-development-and-analytical-solutions/product-development-and-analytical-solutions" },
    ],
  },
];

const ServiceCard = ({ service }:{ service:any }) => (
  <div className="bg-white rounded-xl p-5 h-auto sm:h-90 hover:shadow-xl transition-shadow cursor-pointer">
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-md font-semibold text-blue-900">
        {service.title}
      </h3>
      <img
        src={service.img}
        alt={service.title}
        className="w-8 h-8"
      />
    </div>
    <ul className="text-sm text-blue-900 space-y-2">
      {service.points.map((point:any, idx:number) => (
        <li key={idx}>
          <Link
            to={point.link}
            className="flex items-start transition-transform duration-300 ease-in-out hover:scale-105 hover:translate-x-1"
          >
            <span className="mr-1">›</span> {point.text}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const HeroCards = () => {
  const testimonialCards = services.map((service, index) => (
    <ServiceCard key={index} service={service} />
  ));

  return (
    <div className="-mt-46">
      <Carousel
      title="Our Services"
      titleAlignment="right"
      titleColor="text-white"
      itemsPerPageConfig={{
        mobile: 1,
        tablet: 2,
        desktop: 3,
        large: 4
      }}
      backgroundColor="bg-[#F8F9FB]"
      showArrows={true}
      showDots={true}
      gap="gap-6"
    >
      {testimonialCards}
    </Carousel>
    </div>
  );
};

export default HeroCards;
